import { useContext } from "react";
import ExpandedEntitiesSectionsContext from "../contexts/ExpandedSectionsContext";
const useExpandedSections = () => {
  const currentUser = useContext(ExpandedEntitiesSectionsContext);
  if (!currentUser) {
    throw new Error("useExpandedSections hook needs to be used inside ExpandedSectionsProvider");
  }
  return currentUser;
};
export default useExpandedSections;
